import { ModuleContainer } from 'components/common/styles';
import React from 'react';
import { ItemTabs } from '../../CMFW/layout/ItemTabs';
import ConceptLinkerChecker from './tabs/ConceptLinkerChecker';
import ConceptLinkerAiLinker from './tabs/ConceptLinkerAiLinker';

export type IProps = {
  courseId: number;
};

const ConceptLinker: React.FC<IProps> = (props) => {
  return (
    <ModuleContainer>
      <ItemTabs tabNames={['Checker', 'AI Linker']}>
        <ConceptLinkerChecker courseId={props.courseId} />
        <ConceptLinkerAiLinker courseId={props.courseId} />
      </ItemTabs>
    </ModuleContainer>
  );
};

export default ConceptLinker;
